import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Retail = () => <VerticalPage config={VERTICALS['retail']} />;

export default Retail;
